<!-- eslint-disable max-len -->
<template>
  <v-stepper-content step="B3">
    <v-dialog
      v-model="hasMaxEmployeesDialog"
      max-width="300"
    >
      <v-card>
        <v-card-title>Max Benefit Plans</v-card-title>
        <v-card-text>
          <div>You've reached the maximum number of benefit plans (2). Please submit a separate sheet with the information requested.</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="hasMaxEmployeesDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-col
      cols="12"
      :class="$vuetify.breakpoint.name !== 'sm' ? 'd-flex justify-center mx-0 px-0' : 'd-flex justify-center'"
    >
      <v-card
        flat
        outlined
        rounded="lg"
        :max-width="$vuetify.breakpoint.name === 'xs' ? '95vw' : '75vw'"
        min-height="500px"
      >
        <v-row :class="$vuetify.breakpoint.name === 'xs' ? 'mt-8 mx-1' : 'mt-8 mx-5'">
          <v-col cols="12" class="pb-0">
            <div class="text-md-h4 text-h5" :style="textColor">Current Health Insurance Carrier</div>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              outlined
              label="Current Health Insurance Carrier"
              class="rounded-lg"
              hide-details
              v-model="insurance.carrierName"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="insurance.renewalDate"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="insurance.renewalDate"
                  outlined
                  label="Renewal Date"
                  class="rounded-lg"
                  hide-details
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="insurance.renewalDate"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(insurance.renewalDate)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <!-- Number of enrolled employees -->
          <v-col cols="12" sm="6">
            <v-text-field
              outlined
              label="Total number of enrolled employees"
              class="rounded-lg"
              hide-details
              type="number"
              v-model="insurance.totalEnrolled"
            ></v-text-field>
          </v-col>

          <!-- Years with provider -->
          <v-col cols="12" sm="6">
            <v-text-field
              outlined
              label="Years with current provider"
              class="rounded-lg"
              hide-details
              type="number"
              v-model="insurance.totalYears"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            class="mt-5"
          >
            <div class="text-md-body-1 text-body-2">Have you received renewal rates?</div>
            <v-radio-group
              v-model="renewalRates"
              class="mt-0"
            >
              <v-radio
                label="Yes"
                :value="true"
              ></v-radio>
              <v-radio
                label="No"
                :value="false"
              ></v-radio>
            </v-radio-group>
          </v-col>

          <v-col
            cols="12"
            class="mt-5"
            sm="6"
          >
            <div class="text-md-body-1 text-body-2">Is Claims Experience available for your group?</div>
            <v-radio-group
              v-model="claimsExperience"
              class="mt-0"
            >
              <v-radio
                label="Yes"
                :value="true"
              ></v-radio>
              <v-radio
                label="No"
                :value="false"
              ></v-radio>
            </v-radio-group>
          </v-col>

          <v-col
            cols="12"
            class="mt-5"
          >
            <div class="text-md-body-1 text-body-2">Is your Current Plan Self-Funded?</div>
            <v-radio-group
              v-model="selfFunded"
              row
              class="mt-0"
            >
              <v-radio
                label="Yes"
                :value="0"
              ></v-radio>
              <v-radio
                label="No"
                :value="1"
              ></v-radio>
              <v-radio
                label="Don't Know"
                :value="2"
              ></v-radio>
            </v-radio-group>
          </v-col>

          <v-col cols="12" class="mt-5">
            <v-card
              flat
              outlined
              rounded="lg"
              v-for="(item, index) in insurance.insuranceInfoRates"
              :key="index"
              class="mb-5"
            >
              <v-row class="mx-5">
                <v-col cols="12" class="d-flex-column">
                  <div class="d-flex justify-center text-h6 text-xs-subtitle-2">Benefit Plan #{{ index + 1 }}</div>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    outlined
                    label="Plan Name"
                    class="rounded-lg"
                    hide-details
                    v-model="item.planNumber"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-combobox
                    id="comboTheme"
                    v-model="item.contributionType"
                    :items="contributionTypes"
                    outlined
                    label="Contribution Type"
                    class="rounded-lg"
                  ></v-combobox>
                </v-col>

                <!-- Current Rates -->
                <v-col cols="12" sm="2" class="d-flex">
                  <div class="d-flex align-center">Current Rates</div>
                </v-col>
                <v-col cols="12" sm="4" class="d-flex">
                  <v-text-field
                    v-model="item.currentEmployeeRate"
                    outlined
                    label="Employee"
                    hide-details
                    type="number"
                    class="d-flex align-center"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" class="d-flex">
                  <v-text-field
                    outlined
                    label="Spouse"
                    hide-details
                    v-model="item.currentSpouseRate"
                    type="number"
                    class="d-flex align-center"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" class="d-flex">
                  <v-text-field
                    outlined
                    label="Child"
                    hide-details
                    v-model="item.currentChildRate"
                    type="number"
                    class="d-flex align-center"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" class="d-flex">
                  <v-text-field
                    outlined
                    label="Family"
                    hide-details
                    v-model="item.currentFamilyRate"
                    type="number"
                    class="d-flex align-center"
                  ></v-text-field>
                </v-col>

                <!-- Contribution Rates -->
                <v-col cols="12" sm="2" class="d-flex">
                  <div class="d-flex align-center">Employer Contribution</div>
                </v-col>
                <v-col cols="12" sm="4" class="d-flex">
                  <v-text-field
                    v-model="item.contributionEmployeeRate"
                    outlined
                    label="Employee"
                    hide-details
                    type="number"
                    class="d-flex align-center"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" class="d-flex">
                  <v-text-field
                    outlined
                    label="Spouse"
                    hide-details
                    v-model="item.contributionSpouseRate"
                    type="number"
                    class="d-flex align-center"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" class="d-flex">
                  <v-text-field
                    outlined
                    label="Child"
                    hide-details
                    v-model="item.contributionChildRate"
                    type="number"
                    class="d-flex align-center"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" class="d-flex">
                  <v-text-field
                    outlined
                    label="Family"
                    hide-details
                    v-model="item.contributionFamilyRate"
                    type="number"
                    class="d-flex align-center"
                  ></v-text-field>
                </v-col>

              </v-row>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  large
                  @click="removeBenefitClass(index)"
                >
                  <v-icon left>mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-btn
              color="secondary"
              outlined
              @click="addBenefitClass"
            >
              Add Benefit Plan
            </v-btn>
          </v-col>

          <BenefitsBtnContinue />
        </v-row>
      </v-card>
    </v-col>
  </v-stepper-content>
</template>

<script>
import BenefitsBtnContinue from './btnBenefitsContinue.vue';

export default {
  name: 'BenefitsStepThree',
  components: {
    BenefitsBtnContinue,
  },
  data: () => ({
    menu: false,
    contributionTypes: [
      'Percent',
      'Amount',
    ],
    hasMaxEmployeesDialog: false,
  }),
  computed: {
    textColor() {
      if (this.$vuetify.theme.dark) {
        return 'color: #ffffff';
      }

      return 'color: #2a4f66';
    },
    selfFunded: {
      get() {
        return this.$store.state.benefitsPacket.currentHealthCarrier.selfFunded;
      },
      set(value) {
        this.$store.commit('updateSelfFunded', value);
      },
    },
    insurance: {
      get() {
        return this.$store.state.benefitsPacket.currentHealthCarrier;
      },
      set(value) {
        this.$store.commit('updateCurrentHealthCarrier', value);
      },
    },
    renewalRates: {
      get() {
        return this.$store.state.benefitsPacket.flags.renewalRates;
      },
      set(value) {
        this.$store.commit('updateBenefitsRenewalRate', value);
      },
    },
    claimsExperience: {
      get() {
        return this.$store.state.benefitsPacket.flags.claimsExperience;
      },
      set(value) {
        this.$store.commit('updateClaimsExperience', value);
      },
    },
  },
  methods: {
    download() {
      this.downloadClicked = true;
    },
    addBenefitClass() {
      const bClass = {
        planNumber: null,
        contributionType: null,
        currentChildRate: null,
        currentEmployeeRate: null,
        currentSpouseRate: null,
        currentFamilyRate: null,
        renewalChildRate: null,
        renewalEmployeeRate: null,
        renewalSpouseRate: null,
        renewalFamilyRate: null,
        contributionChildRate: null,
        contributionEmployeeRate: null,
        contributionSpouseRate: null,
        contributionFamilyRate: null,
      };

      // Max number of 2
      if (this.insurance.insuranceInfoRates.length <= 1) {
        this.insurance.insuranceInfoRates.push(bClass);
      } else {
        this.hasMaxEmployeesDialog = true;
      }
    },
    removeBenefitClass(value) {
      this.insurance.insuranceInfoRates.splice(value, 1);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
